import { render } from "./Section2Showcase.vue?vue&type=template&id=40e85f8a&scoped=true"
import script from "./Section2Showcase.vue?vue&type=script&lang=js"
export * from "./Section2Showcase.vue?vue&type=script&lang=js"

import "./Section2Showcase.vue?vue&type=style&index=0&id=40e85f8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e85f8a"]])

export default __exports__